@if (selectShowAngebot$ && mainFilename$ | async; as mainFilename) {
  <ph-angebot
    *axLazyElement="'ph-angebot/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></ph-angebot>
}
